export default function About() {
    return (
        <div>
            This is about
        </div>
    );
}